// Logger client (navigateur) — wrapper léger au-dessus de console.*.
//
// pino n'est PAS utilisable tel quel côté navigateur (dépendances Node). Ici on
// fournit la MÊME API (debug/info/warn/error) que le logger serveur, pour que le
// code applicatif importe toujours `logger` sans se soucier de l'environnement.
//
// Comportement par niveau (réduction du bruit en prod) :
//  - dev  : tout est affiché (debug compris), avec préfixe lisible.
//  - prod : seuls warn/error sortent ; debug/info sont silencieux.
//    → on garde les vraies anomalies en prod sans polluer la console des
//      visiteurs avec le bruit de debug.
//
// Surcharge possible : window.__LOG_LEVEL__ = "debug" (depuis la console du
// navigateur) ré-active les logs verbeux en prod ponctuellement, sans rebuild.

const isDev = process.env.NODE_ENV !== "production";

const LEVELS = { debug: 10, info: 20, warn: 30, error: 40, silent: 100 };

function resolveLevel() {
    // Priorité à une surcharge runtime posée dans la console navigateur.
    if (typeof window !== "undefined" && window.__LOG_LEVEL__) {
        const lvl = String(window.__LOG_LEVEL__).toLowerCase();
        if (LEVELS[lvl] != null) return LEVELS[lvl];
    }
    return isDev ? LEVELS.debug : LEVELS.warn;
}

// Formatte les arguments : si le 1er arg est un objet de contexte (façon pino :
// logger.info({foo:1}, "msg")), on le rend en second pour rester lisible en
// console. Sinon on passe les args tels quels.
function emit(consoleFn, args) {
    consoleFn(...args);
}

function make(levelName, consoleFn) {
    const threshold = LEVELS[levelName];
    return (...args) => {
        if (threshold < resolveLevel()) return;
        emit(consoleFn, args);
    };
}

// On bind sur les bonnes méthodes console pour préserver la source (fichier:ligne)
// dans la console navigateur — un wrapper qui appelle console.log perdrait la
// localisation ; ici chaque niveau cible directement la bonne méthode.
const logger = {
    debug: make("debug", (...a) => console.debug(...a)),
    info: make("info", (...a) => console.info(...a)),
    warn: make("warn", (...a) => console.warn(...a)),
    error: make("error", (...a) => console.error(...a)),
    // Parité d'API avec le logger serveur (no-op côté client : pas d'enfants).
    child() {
        return logger;
    },
};

export default logger;
